document.addEventListener("DOMContentLoaded", function () {
    const playlist = window.playlist;
    const audio = document.getElementById("audio");
    const playBtn = document.getElementById("play");
    const seek = document.getElementById("seek");
    const time = document.getElementById("time");
    const volume = document.getElementById("volume");
    const trackInfo = document.getElementById("trackInfo");
    const prevBtn = document.getElementById("prev");
    const nextBtn = document.getElementById("next");

    if (!playlist?.length || !audio || !playBtn || !seek || !time || !volume || !trackInfo || !prevBtn || !nextBtn) {
        console.warn("Audio player: missing required elements or playlist data.");
        return;
    }

    let currentTrack = 0;
    let hasError = false;

    const loadTrack = (index) => {
        const track = playlist[index];
        if (!track) return;
        hasError = false;
        audio.src = track.src;
        trackInfo.textContent = track.title;
        audio.load();
    };

    const formatTime = (seconds) => {
        if (!Number.isFinite(seconds)) return "0:00";
        const min = Math.floor(seconds / 60);
        const sec = Math.floor(seconds % 60)
            .toString()
            .padStart(2, "0");
        return `${min}:${sec}`;
    };

    const setTimeDisplay = (current, total) => {
        time.textContent = `${formatTime(current)} / ${formatTime(total)}`;
    };

    playBtn.addEventListener("click", () => {
        if (hasError) return;
        if (audio.paused) {
            audio.play().catch((err) => {
                console.error("Audio playback error: ", err);
            });
            playBtn.className = "player__play playing";
        } else {
            audio.pause();
            playBtn.className = "player__play paused";
        }
    });

    audio.addEventListener("loadedmetadata", () => {
        seek.max = audio.duration || 0;
        setTimeDisplay(0, audio.duration);
    });

    audio.addEventListener("timeupdate", () => {
        seek.value = audio.currentTime;
        setTimeDisplay(audio.currentTime, audio.duration);
    });

    audio.addEventListener("error", () => {
        hasError = true;
        seek.max = 0;
        seek.value = 0;
        setTimeDisplay(0, 0);
        trackInfo.textContent = "Error with audio playback.";
        playBtn.className = "player__play error";
        console.warn("Audio player: failed to load audio file.", audio.src);
    });

    seek.addEventListener("input", () => {
        audio.currentTime = seek.value;
    });

    volume.addEventListener("input", () => {
        audio.volume = volume.value;
    });

    const playTrack = (index) => {
        loadTrack(index);
        audio.play().catch((err) => {
            hasError = true;
            console.error("Audio playback error: ", err);
            trackInfo.textContent = "Error with audio playback.";
            playBtn.className = "player__play error";
        });
        playBtn.className = "player__play playing";
    };

    nextBtn.addEventListener("click", () => {
        currentTrack = (currentTrack + 1) % playlist.length;
        playTrack(currentTrack);
    });

    prevBtn.addEventListener("click", () => {
        currentTrack = (currentTrack - 1 + playlist.length) % playlist.length;
        playTrack(currentTrack);
    });

    audio.addEventListener("ended", () => {
        playBtn.className = "player__play paused";
        seek.value = 0;
        setTimeDisplay(0, audio.duration);

        // to play next track in list automatically:
        // nextBtn.click();
    });

    // Load initial track
    loadTrack(currentTrack);
});
